export default "assets/images/logo-secondary-18bd05e4.svg";